import { render, staticRenderFns } from "./SiteDetails.vue?vue&type=template&id=3d56f74c&scoped=true"
import script from "./SiteDetails.vue?vue&type=script&lang=js"
export * from "./SiteDetails.vue?vue&type=script&lang=js"
import style0 from "./SiteDetails.vue?vue&type=style&index=0&id=3d56f74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d56f74c",
  null
  
)

export default component.exports